/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

export const tagStyle = {
  container: {
    padding: "0.75rem",
    backgroundColor: "primaryPale",
    borderRadius: "0.25rem",
    alignItems: "center",
    gap: "0.5rem",
    width: "fit-content",
    "&::before": {
      content: '""',
      width: "0.5rem",
      height: "0.5rem",
      backgroundColor: "secondary.main",
      borderRadius: "50%"
    }
  },
};
